// Prod Settings
// export const environment = {
//   version: 'https://o3-cloud-lean-angular.azurewebsites.net/assets/js/version.json',
//   production: true,
//   O3CoreApiUrl: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
//   ApiUrl: 'https://o3-live-node-api.o3manufacturing.com:90/api/',
//   ImageUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   O3ImageUrl: 'https://o3-live-net-app.azurewebsites.net/',
//   NotificationUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
//   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
//   companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
//   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
//   api_version: 'v1.0.0',
//   white_listed_Domains: [
//     'https://o3-cloud-gateway-api.azurewebsites.net/'
//   ],
//   api_baseurl: 'https://o3-cloud-gateway-api.azurewebsites.net/',
//   api_signalR_baseUrl: 'https://o3-ms-auth-api.azurewebsites.net/',
//   api_baseurlUty: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
//   api_prefix: 'api/',
//   core_app_url: 'https://o3-cloud-core-angular.azurewebsites.net/login',
//   uiBuilder_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
//   utility_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
//   firebaseConfig: {
//     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
//     authDomain: "o3-push-notification.firebaseapp.com",
//     projectId: "o3-push-notification",
//     storageBucket: "o3-push-notification.appspot.com",
//     messagingSenderId: "372705983827",
//     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
//     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
//   }
// }








export const environment = {
  version: 'https://uatlean.o3ai.com/assets/js/version.json',
  production: true,
  O3CoreApiUrl: 'https://localhost:8051/api/',
  //O3CoreApiUrl: 'https://oig-uat-gateway-api.azurewebsites.net/api/',
  workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
  blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
  companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
  LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
  api_version: 'v1.0.0',
  white_listed_Domains: [
    'https://o3-cloud-gateway-api.azurewebsites.net/'
  ],
  api_baseurl: 'https://o3-cloud-gateway-api.azurewebsites.net/',
  api_signalR_baseUrl: 'https://o3-cloud-auth-api.azurewebsites.net/',
  api_baseurlUty: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
  api_prefix: 'api/',
  core_app_url: 'https://uat.o3ai.com/login',
  uiBuilder_app_url: 'https://uat-ui-builder.o3ai.com/login',
  utility_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
  leanApiUrl: 'https://o3-cloud-lean-api.azurewebsites.net/',
  firebaseConfig: {
    apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
    authDomain: "o3-push-notification.firebaseapp.com",
    projectId: "o3-push-notification",
    storageBucket: "o3-push-notification.appspot.com",
    messagingSenderId: "372705983827",
    appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
    vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
  }
}












// export const environment = {
//   version: 'https://oiglean.o3ai.com/assets/js/version.json',
//   production: true,
//   O3CoreApiUrl: 'https://oigapi.o3ai.com/api/',
//   workFLowApi: 'https://o3-live-workflow-api.azurewebsites.net/api/',
//   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
//   companyKey: '03182ffc-c62e-44e6-9004-ae70599a2950', //o3 manufacturing
//   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbotoig',
//   api_version: 'v1.0.0',
//   white_listed_Domains: [
//     'https://oigapi.o3ai.com/'
//   ],
//   api_baseurl: 'https://oigapi.o3ai.com/',
//   api_signalR_baseUrl: 'https://live-o3-auth-api.azurewebsites.net/',
//   api_baseurlUty: 'https://oigapi.o3ai.com/api/',
//   api_prefix: 'api/',
//   core_app_url: 'https://oiglive.o3ai.com/login',
//   uiBuilder_app_url: 'https://live-o3-uibuilder-angular.azurewebsites.net/login',
//   utility_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
//   leanApiUrl: 'https://live-o3-lean-api.azurewebsites.net/',
//   firebaseConfig: {
//     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
//     authDomain: "o3-push-notification.firebaseapp.com",
//     projectId: "o3-push-notification",
//     storageBucket: "o3-push-notification.appspot.com",
//     messagingSenderId: "372705983827",
//     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
//     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
//   }
// }
